var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-preview",on:{"click":_vm.handleClose}},[_c('img',{attrs:{"src":_vm.imgInfo.url,"alt":""},on:{"click":function($event){$event.stopPropagation();}}}),_c('div',{staticClass:"btn",on:{"click":function($event){$event.stopPropagation();return _vm.setChatBg.apply(null, arguments)}}},[_vm._v("Set as chat background")])])
}
var staticRenderFns = []

export { render, staticRenderFns }